export const toCapitalize = (str: string | undefined): string => {
  return str ? str[0].toUpperCase() + str.substring(1) : ''
}
